module.exports = __webpack_public_path__ + "static/media/newsmob.34ac5008.png";